import { render, staticRenderFns } from "./DocHdgTxt.vue?vue&type=template&id=20544d0c&"
import script from "./DocHdgTxt.vue?vue&type=script&lang=js&"
export * from "./DocHdgTxt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports